export default "__VITE_ASSET__CfCM_6qa__"